<template>
  <div>
    <div class="page-content">
      <div class="col-lg-12 col-xl-12 stretch-card">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-lg-12">
                <h4 style="margin-right: 5px" class="float-start">
                  DETAIL MPR PENGAJUAN
                  <span class="badge bg-primary">{{ head?.status }}</span>
                </h4>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row my-4">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Request No</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          readonly
                          :value="head.request_no"
                          class="form-control"
                          placeholder="Request No"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Customer Team</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-bind:value="head.customer_team"
                          disabled
                          class="form-control"
                          placeholder="Customer Team"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Jenis Driver</label
                      >
                      <div class="col-sm-9">
                        <!-- <multiselect
                          v-model="jenisDriver"
                          :show-labels="false"
                          :options="fetchJenisDriver"
                          placeholder="Please Select"
                          track-by="value"
                          label="value"
                        ></multiselect> -->
                        <input
                          type="text"
                          v-model="temp.jenis_driver"
                          disabled
                          class="form-control"
                          placeholder="Jenis Driver"
                        />
                        <div v-show="errors.jenis_driver">
                          <div
                            v-for="error in errors.jenis_driver"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Tanggal Dibutuhkan</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="temp.need_date"
                          disabled
                          class="form-control"
                          placeholder="Tanggal Dibutuhkan"
                        />
                        <div v-if="errors.need_date">
                          <div
                            v-for="error in errors.need_date"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Opsi</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="temp.opsi"
                          disabled
                          class="form-control"
                          placeholder="Opsi"
                        />
                        <div v-if="errors.opsi">
                          <div
                            v-for="error in errors.opsi"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Kriteria Driver</label
                      >
                      <div class="col-sm-9">
                        <!-- <multiselect
                          multiple
                          v-model="kriteriaDriver"
                          :options="fetchKriteriaDriver"
                          placeholder="Please Select"
                        ></multiselect> -->
                        <input
                          type="text"
                          v-model="temp.kriteria_driver"
                          disabled
                          class="form-control"
                          placeholder="Kriteria Driver"
                        />
                        <div v-if="errors.kriteria_driver">
                          <div
                            v-for="error in errors.kriteria_driver"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Pengganti Driver</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="temp.driver_replace"
                          disabled
                          class="form-control"
                          placeholder="Pengganti Driver"
                        />
                        <div v-if="errors.driver_replace">
                          <div
                            v-for="error in errors.driver_replace"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Nomor Polisi</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="temp.vehicle_no"
                          disabled
                          class="form-control"
                          placeholder="Nomor Polisi"
                        />
                        <div v-if="errors.vehicle_no">
                          <div
                            v-for="error in errors.vehicle_no"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Tipe Unit</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          disabled
                          v-model="temp.tipe_unit"
                          class="form-control"
                          placeholder="Tipe Unit"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Sim</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          disabled
                          v-model="temp.sim"
                          class="form-control"
                          placeholder="Sim"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Lokasi</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="temp.location"
                          disabled
                          class="form-control"
                          placeholder="Lokasi"
                        />
                        <div v-if="errors.location">
                          <div
                            v-for="error in errors.location"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Project</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="temp.project"
                          disabled
                          class="form-control"
                          placeholder="Project"
                        />
                        <div v-if="errors.project">
                          <div
                            v-for="error in errors.project"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Catatan</label>
                      <div class="col-sm-9">
                        <textarea
                          class="form-control"
                          v-model="temp.remarks_request"
                          disabled
                        ></textarea>
                        <div v-if="errors.remarks_request">
                          <div
                            v-for="error in errors.remarks_request"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row my-4">
              <div class="card">
                <div class="card-body">
                  <vue-good-table
                    title="list-user"
                    :line-numbers="true"
                    :isLoading.sync="isLoading"
                    :rows="details"
                    :columns="columns"
                    :sort-options="{
                      enabled: false,
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                        <a
                          href="#"
                          title="Edit"
                          @click.prevent="editDetail(props.index, props.row)"
                        >
                          <i
                            class="mdi mdi-eye-outline"
                            style="font-size: 16px"
                          ></i>
                        </a>
                      </span>
                      <span v-else-if="props.column.field == 'request_no'">
                        {{ head?.request_no }}
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <button
                class="btn btn-warning text-black fw-bolder btn-icon-text"
                @click="backForm"
                type="button"
              >
                <i class="link-icon" data-feather="arrow-left"></i>
                {{ $t("backMess") }}
              </button>
              &nbsp;&nbsp;&nbsp;
              <button
                class="btn btn-primary float-end btn-sm mx-1"
                @click="sendData"
                type="button"
              >
                {{ $t("submitFormTxt") }}
                <i class="mdi mdi-send" style="font-size: 16px"></i>
              </button>
              <button
                class="btn btn-primary float-end btn-sm mx-1"
                @click="cancelData"
                v-show="head.status == 'Draft'"
                type="button"
              >
                <i class="mdi mdi-block-helper" style="font-size: 16px"></i>
                Cancel
              </button>
              <button
                class="btn btn-primary float-end btn-sm mx-1"
                @click="editData"
                v-show="head.status == 'Draft'"
                type="button"
              >
                <i class="mdi mdi-square-edit-outline"></i>
                {{ $t("editMess") }}
              </button>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreatePengajuan",
  components: {},
  data() {
    return {
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      forms: {},
      head: {
        request_no: null,
        customer_team: null,
      },
      jenisDriver: null,
      fetchJenisDriver: [],
      opsi: null,
      fetchOptions: [],
      driverReplaced: null,
      fetchDriver: [],
      nomorPolisi: null,
      fetchNomorPolisi: [],
      location: null,
      fetchLocation: [],
      project: null,
      fetchProject: [],
      kriteriaDriver: null,
      fetchKriteriaDriver: [],
      temp: {
        tipe_unit: null,
        sim: null,
      },
      details: [],
      isActiveFlag: true,
      columns: [
        {
          label: "Action",
          field: "actions",
        },
        {
          label: "Request No",
          field: "request_no",
        },
        {
          label: "Jenis Driver",
          field: "jenis_driver",
        },
        {
          label: "Opsi",
          field: "opsi",
        },
        {
          label: "Pengganti",
          field: "driver_replace",
        },
        {
          label: "Nopol",
          field: "vehicle_no",
        },
        {
          label: "Tipe Unit",
          field: "tipe_unit",
        },
        {
          label: "SIM",
          field: "sim",
        },
        {
          label: "Lokasi",
          field: "location",
        },
        {
          label: "Project",
          field: "project",
        },
        {
          label: "Kriteria Driver",
          field: "kriteria_driver",
        },
        {
          label: "Tgl Dibutuhkan",
          field: "need_date",
        },
        {
          label: "Catatan Ops",
          field: "remarks_request",
        },
      ],
      currentIndex: 1,
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
    };
  },
  watch: {
    opsi(newData) {
      this.driverReplaced = null;
      if (newData == null) {
        this.isActiveFlag = true;
      } else {
        if (newData?.value == "PERGANTIAN") {
          this.isActiveFlag = false;
        } else {
          this.isActiveFlag = true;
        }
      }
    },
    nomorPolisi(newData) {
      console.log(newData);
      if (newData == null) {
        this.temp.sim = null;
        this.temp.tipe_unit = null;
      } else {
        this.temp.sim = newData.sim;
        this.temp.tipe_unit = newData.type_truck;
      }
    },
  },
  methods: {
    cancelData(){
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataCancel"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          const baseURI = this.$settings.endPointMPR + "v1/mpr/pengajuan/submit-to-cancel/"+this.head.master_mpr_id;
          this.$http
            .patch(baseURI)
            .then((response) => {
              this.isLoading = false;
              if (response.data.status === 200) {

                var params = this.$onRandom(this.head.master_mpr_id);
                window.location.href =
                  "/mpr-pengajuan/detail/" + params + "?status=200&msg=Successfully";
              } else {
                this.errors = response.data.errors;
                //this.resultError(response.data.errors);
                this.loadError(this.errors.message);
              }
            })
            .catch((error) => {
              this.isloading = false;
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                }
              }
            });
        }
      });
    },
    sendData(){
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          const baseURI = this.$settings.endPointMPR + "v1/mpr/pengajuan/submit-to-open/"+this.head.master_mpr_id;
          this.$http
            .patch(baseURI)
            .then((response) => {
              this.isLoading = false;
              if (response.data.status === 200) {

                var params = this.$onRandom(this.head.master_mpr_id);
                window.location.href =
                  "/mpr-pengajuan/detail/" + params + "?status=200&msg=Successfully";
              } else {
                this.errors = response.data.errors;
                //this.resultError(response.data.errors);
                this.loadError(this.errors.message);
              }
            })
            .catch((error) => {
              this.isloading = false;
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                }
              }
            });
        }
      });
    },
    editData() {
      window.location.href = "/mpr-pengajuan/edit/" + this.$route.params.id;
    },
    loadData(id) {
      const baseURI =
        this.$settings.endPointMPR + "v1/mpr/pengajuan/detail/" + id;
      return this.$http.get(baseURI).then((response) => {
        let res = response.data.datas;
        this.head.master_mpr_id = res.master_mpr_id;
        this.head.request_no = res.request_no;
        this.head.status = res.status;
        this.head.customer_team = res.customer_team;
        this.details = res.details;
        // this.form={ name: 'asep', usernmae:res.username };
      });
    },
    submitData() {
      let payload = {};
      payload.request_no = this.requestNo;
      payload.customer_team = this.head?.customer_team;
      payload.details = this.details;
      this.isLoading = true;
      const baseURI = this.$settings.endPointMPR + "v1/mpr/pengajuan/create";
      this.$http
        .post(baseURI, payload)
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            console.log(response);
          } else {
            this.errors = response.data.errors;
            //this.resultError(response.data.errors);
            this.loadError(this.errors.message);
          }
        })
        .catch((error) => {
          this.isloading = false;
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            }
          }
        });
    },
    deleteDetail(index) {
      if (this.currentIndex == this.details.length) {
        if (index == this.currentIndex) {
          this.currentIndex--;
          this.clear();
        }
      } else {
        if (this.currentIndex == index) {
          this.clear();
        }
      }
      this.$delete(this.details, index);
    },
    editDetail(index, row) {
      this.currentIndex = index;
      this.clear();
      this.temp.need_date = row.need_date;
      this.temp.remarks_request = row.remarks_request;
      this.temp.jenis_driver = row.jenis_driver;
      this.temp.opsi = row.opsi;
      this.temp.driver_id = row.driver_id;
      this.temp.vehicle_no = row.vehicle_no;
      this.temp.sim = row.sim;
      this.temp.tipe_unit = row.tipe_unit;
      this.temp.location = row.location;
      this.temp.kriteria_driver = row.kriteria_driver;
      this.temp.project = row.project;
      this.temp.driver_replace = row.driver_replace;
      this.temp.remarks_request = row.remarks_request;
    },
    addData() {
      this.currentIndex++;
      this.clear();
    },
    clear() {
      this.temp = {
        tipe_unit: null,
        sim: null,
        need_date: new Date(),
      };
      this.jenisDriver = null;
      this.opsi = null;
      this.driverReplaced = null;
      this.nomorPolisi = null;
      this.location = null;
      this.project = null;
      this.kriteriaDriver = null;
    },

    validateData(data) {
      let res = true;
      this.errors = [];
      if (!data.jenis_driver) {
        this.$set(this.errors, "jenis_driver", ["Empty Value"]);
        res = false;
      }
      if (!data.need_date) {
        this.$set(this.errors, "need_date", ["Empty Value"]);
        res = false;
      }
      if (!data.driver_replace && data?.opsi == "PERGANTIAN") {
        this.$set(this.errors, "driver_replace", ["Empty Value"]);
        res = false;
      }
      if (!data.vehicle_no) {
        this.$set(this.errors, "vehicle_no", ["Empty Value"]);
        res = false;
      }
      if (!data.location) {
        this.$set(this.errors, "location", ["Empty Value"]);
        res = false;
      }
      if (!data.project) {
        this.$set(this.errors, "project", ["Empty Value"]);
        res = false;
      }
      if (!data.kriteria_driver) {
        this.$set(this.errors, "kriteria_driver", ["Empty Value"]);
        res = false;
      }
      if (!data.opsi) {
        this.$set(this.errors, "opsi", ["Empty Value"]);
        res = false;
      }

      if (!res) {
        this.resultError(this.errors);
      }

      return res;
    },
    saveDetail() {
      let detail = this.details;
      let temp = { ...this.temp };
      temp.need_date =
        this.temp.need_date.length == 10
          ? this.temp.need_date
          : this.temp.need_date.toISOString().split("T")[0];

      temp.id = this.currentIndex;
      temp.request_no = this.requestNo;
      temp.vehicle_no = this.nomorPolisi?.vehicle_no;
      temp.jenis_driver = this.jenisDriver?.value;
      temp.opsi = this.opsi?.value;
      temp.kriteria_driver = this.kriteriaDriver
        ? this.kriteriaDriver.join(";")
        : "";
      temp.driver_replace = this.driverReplaced?.driver_id;
      temp.project = this.project?.name;
      if (!this.validateData(temp)) {
        return;
      }
      if (detail.length == 0) {
        detail.push({ ...temp });
        this.currentIndex = detail.length;
      } else {
        // After Save Detail & Not Click Add
        if (detail.length == this.currentIndex) {
          detail.splice(this.currentIndex - 1, 1, temp);
        }
        // Edit Detail
        else if (detail.length > this.currentIndex) {
          detail.splice(this.currentIndex, 1, temp);
        }
        // Total Detail <> CurrentIndex (Add Triggered)
        else {
          this.details.push({ ...temp });
          this.currentIndex = detail.length;
        }
      }

      this.details = detail;
      temp = null;
    },
    loadDriver() {
      const baseURI = this.$settings.endPointMPR + `v1/mpr/lookup/drivers`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchDriver = response.data.datas.data;
      });
    },
    asyncSearchDriver(search) {
      this.fetchDriver = [];
      const baseURI =
        this.$settings.endPointMPR +
        `v1/mpr/lookup/drivers?driver_id=${search}`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchDriver = response.data.datas.data;
      });
    },
    asyncSearchTruck(search) {
      this.fetchNomorPolisi = [];
      const baseURI =
        this.$settings.endPointMPR +
        `v1/mpr/lookup/trucks?vehicle_no=${search}`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchNomorPolisi = response.data.datas.data;
      });
    },
    loadTruck() {
      const baseURI = this.$settings.endPointMPR + `v1/mpr/lookup/trucks`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchNomorPolisi = response.data.datas.data;
      });
    },
    loadBranch() {
      const baseURI = this.$settings.endPointMPR + `v1/mpr/lookup/branch`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchLocation = response.data.datas;
      });
    },
    asyncLoadCustomer(search) {
      this.fetchProject = [];
      const baseURI =
        this.$settings.endPointMPR +
        `v1/mpr/lookup/ct-customers?name=${search}`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchProject = response.data.datas.data;
      });
    },
    loadCustomer() {
      const baseURI = this.$settings.endPointMPR + `v1/mpr/lookup/ct-customers`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchProject = response.data.datas.data;
      });
    },
    loadDriverKriteria() {
      const baseURI =
        this.$settings.endPointMPR + `v1/mpr/lookup/driver-criteria`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchKriteriaDriver = response.data.datas;
      });
    },
    loadJenisDriver() {
      const baseURI = this.$settings.endPointMPR + `v1/mpr/lookup/jenis-driver`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchJenisDriver = response.data.datas;
      });
    },
    loadOptionDriver() {
      const baseURI = this.$settings.endPointMPR + `v1/mpr/lookup/opsi-driver`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchOptions = response.data.datas;
      });
    },
    loadCustomerTeam() {
      this.fade(true);
      const baseURI =
        this.$settings.endPointMPR + "v1/mpr/lookup/customer-team-by-user";
      this.$http
        .get(baseURI)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.head.customer_team = response?.data?.datas[0];
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              if (this.errors.message) {
                this.error(this.errors.message);
              } else {
                this.resultError(error.response.data.errors);
              }
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push("/page-not-found");
            }
          }
          //this.resetForm();
        });
    },
    loadOption() {
      this.loadCustomerTeam();
      this.loadJenisDriver();
      this.loadOptionDriver();
      this.loadDriverKriteria();
      this.loadBranch();
      this.loadCustomer();
      this.loadTruck();
      this.loadDriver();
    },
    backForm() {
      window.location.href = "/mpr-pengajuan";
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MprPenerimaanController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },
    cek_message(status, msg) {
      if (status == '200') {
        this.success(msg);
      }
    },
  },
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    this.fetchIt();
    this.loadData(params[0]);
    this.cek_message(this.$route.query.status, this.$route.query.msg);
  },
};
</script>
